import { BrowserRouter, Route, Routes } from "react-router-dom";
import ErrorPage from "../ErrorPage";
import AboutUs from "../AboutUs";
import Payment from "../Payment";
import PrivacyPolicy from "../PrivacyPolicy";
import Terms from "../Terms";
import React, { CSSProperties, Suspense } from "react";
import RiseLoader from "react-spinners/RiseLoader";
import Home from "../Home";

const Flight = React.lazy(() => import("../Flight"));
const Interstate = React.lazy(() => import("../Interstate"));
const InterstateCheckout = React.lazy(() => import("../Interstate/Checkout"));
const InterstateCheckoutSuccess = React.lazy(
  () => import("../Interstate/CheckoutSuccess"),
);
const LagBus = React.lazy(() => import("../Commute/LagBus"));
const Train = React.lazy(() => import("../Commute/Train"));
const Cowry = React.lazy(() => import("../Commute/Cowry"));
const CommuteCheckout = React.lazy(() => import("../Commute/Checkout"));
const CommuteCheckoutSuccess = React.lazy(
  () => import("../Commute/CheckoutSuccess"),
);
const CowryFundSuccess = React.lazy(() => import("../Commute/FundSuccess"));
//const Home = React.lazy(() => import("./Home"));
const FlightSearch = React.lazy(() => import("../FlightSearch"));
const FlightFinalOffer = React.lazy(() => import("../FlightFinalOffer"));
const FlightCheckoutConfirming = React.lazy(
  () => import("../FlightFinalOffer/CheckoutConfirming"),
);
const Profile = React.lazy(() => import("../Profile"));
const Loyalty = React.lazy(() => import("../Loyalty"));
const ProfileMenu = React.lazy(() => import("../ProfileMenu"));
const Layout = React.lazy(() => import("../Layout"));

const override: CSSProperties = {
  display: "block",
  margin: "0 auto",
  borderColor: "#000046",
};

export const MainROute = ({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: any;
}) => {
  return (
    <BrowserRouter>
      <Suspense
        fallback={
          <div
            className="w-full items-center h-screen flex justify-center"
            key={0}
          >
            <RiseLoader
              color={"#000046"}
              loading={true}
              cssOverride={override}
              size={10}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
        }
      >
        <Layout isOpen={isOpen} setIsOpen={setIsOpen}>
          <Routes>
            <Route path="/" element={<Home />} errorElement={<ErrorPage />} />
            <Route
              path="/flights"
              element={<Flight />}
              errorElement={<ErrorPage />}
            />
            <Route
              path="/interstate"
              element={<Interstate />}
              errorElement={<ErrorPage />}
            />
            <Route
              path="/interstate/checkout"
              element={<InterstateCheckout />}
              errorElement={<ErrorPage />}
            />
            <Route
              path="/interstate/checkout/success"
              element={<InterstateCheckoutSuccess />}
              errorElement={<ErrorPage />}
            />
            <Route
              path="/lagbus"
              element={<LagBus />}
              errorElement={<ErrorPage />}
            />
            <Route
              path="/train"
              element={<Train />}
              errorElement={<ErrorPage />}
            />
            <Route
              path="/cowry"
              element={<Cowry />}
              errorElement={<ErrorPage />}
            />
            <Route
              path="/cowry/success"
              element={<CowryFundSuccess />}
              errorElement={<ErrorPage />}
            />
            <Route
              path="/commute/checkout"
              element={<CommuteCheckout />}
              errorElement={<ErrorPage />}
            />
            <Route
              path="/commute/checkout/success"
              element={<CommuteCheckoutSuccess />}
              errorElement={<ErrorPage />}
            />
            <Route
              path="/final"
              element={<FlightFinalOffer />}
              errorElement={<ErrorPage />}
            />
            <Route
              path="/final/confirming"
              element={<FlightCheckoutConfirming />}
              errorElement={<ErrorPage />}
            />
            <Route
              path="/flights/results/:search"
              element={<FlightSearch />}
              errorElement={<ErrorPage />}
            />
            <Route
              path="/payment/:feature/:ref"
              element={<Payment />}
              errorElement={<ErrorPage />}
            />
            <Route
              path="/profile"
              element={<Profile />}
              errorElement={<ErrorPage />}
            />
            <Route
              path="/policy"
              element={<PrivacyPolicy />}
              errorElement={<ErrorPage />}
            />
            <Route
              path="/about"
              element={<AboutUs />}
              errorElement={<ErrorPage />}
            />
            <Route
              path="/terms"
              element={<Terms />}
              errorElement={<ErrorPage />}
            />
            <Route
              path="/my_loyalty"
              element={<Loyalty />}
              errorElement={<ErrorPage />}
            />
            <Route
              path="/profile_menu"
              element={<ProfileMenu />}
              errorElement={<ErrorPage />}
            />
            <Route
              path="/error"
              element={<ErrorPage />}
              errorElement={<ErrorPage />}
            />
          </Routes>
        </Layout>
      </Suspense>
    </BrowserRouter>
  );
};
